const hasExtension = (name) => /\.[a-z0-9]{2,10}$/i.test(String(name || '').trim());

const extFromContentType = (contentType) => {
  const value = String(contentType || '').toLowerCase().split(';')[0].trim();
  const map = {
    'application/pdf': '.pdf',
    'application/zip': '.zip',
    'application/x-zip-compressed': '.zip',
    'application/x-rar-compressed': '.rar',
    'application/vnd.rar': '.rar',
    'application/x-7z-compressed': '.7z',
    'application/x-tar': '.tar',
    'application/gzip': '.gz',
    'application/x-gzip': '.gz',
    'video/mp4': '.mp4',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
  };
  return map[value] || '';
};

export const downloadBlobResponse = (response, fallbackName) => {
  if (!response?.data) {
    throw new Error('No se recibio archivo para descargar');
  }

  const disposition = response.headers?.['content-disposition'] || '';
  const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  const plainMatch = disposition.match(/filename="?([^"]+)"?/i);
  const fromHeader = utfMatch?.[1] ? decodeURIComponent(utfMatch[1]) : plainMatch?.[1];
  const fallback = fallbackName || 'archivo';
  const contentType = response.headers?.['content-type'] || '';

  let fileName = String(fromHeader || fallback).trim();
  if (!hasExtension(fileName)) {
    const ext = extFromContentType(contentType);
    if (ext) {
      fileName = `${fileName}${ext}`;
    }
  }

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
  window.URL.revokeObjectURL(url);
};
